import React, { useEffect, useState } from 'react';

import { Flex, Select, Typography } from 'antd';
import IconAsText from 'src/components/IconAsText';
import antdIconsMap from 'src/common/mapping/antdIconsMap';

export default function SelectIcon(
	{
		defaultIcon,
		onIconChange,
	}: {
		defaultIcon?: string
		onIconChange?: (value: string) => void
	}
) {
	const [ selectedIcon, setSelectedIcon, ] = useState<string>(defaultIcon??'');

	useEffect(() => {
		onIconChange && onIconChange(selectedIcon);
	}, [ selectedIcon, ]);

	const handleIconChange = (value: any) => {
		if(typeof value === 'string'){
			setSelectedIcon(value);
		}
	};

	return (
		<Select
			value={selectedIcon}
			placeholder={'Ícone'}
			showSearch
			onChange={handleIconChange}
			options={Object.entries(antdIconsMap)?.map(
				([ index, ]) => {
					return {
						label: (
							<Flex align='center' gap={10}>
								<IconAsText
									icon={
										index as keyof typeof antdIconsMap
									}
									color='black'
								/>
								<Typography.Text>{index}</Typography.Text>
							</Flex>
						),
						value: index,
					};
				}
			)}
		/>
	);
}
